import React, { useRef, useState, useEffect } from "react";
import { Col, Media, Tooltip, UncontrolledTooltip } from "reactstrap";

import helpImg from '../../../images/icons/help2.png';
import quickHelpImg from '../../../images/icons/quick_help.png';
import moneyHistoryImg from '../../../images/icons/money_history.png';
import pointsHistoryImg from '../../../images/icons/points_history.png';
import blockedUsersImg from '../../../images/icons/blocked_users.png';
import gameHelpImg from '../../../images/icons/game_help.png';

const BottomBarOld = ({
    t,
    member,
    toggleSupport,
    handleClickStart,
    toggleBalanceHistory,
    togglePointsHistory,
    toggleBannedUsers,
    toggleHelp,
    toggleAbout,
    toggleTermsOfUse,
    helpPageOpen,
    termsOfUseOpen,
}) => {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const [isOverflowingFooter1, setIsOverflowingFooter1] = useState(false);
    const [isOverflowingFooter2, setIsOverflowingFooter2] = useState(false);
    const [isOverflowingFooter3, setIsOverflowingFooter3] = useState(false);
    const [isOverflowingFooter4, setIsOverflowingFooter4] = useState(false);
    const [isOverflowingFooter5, setIsOverflowingFooter5] = useState(false);
    const [isOverflowingFooter6, setIsOverflowingFooter6] = useState(false);
    const [isOverflowingFooter7, setIsOverflowingFooter7] = useState(false);
    const [isOverflowingFooter8, setIsOverflowingFooter8] = useState(false);


    const footerRef1 = useRef(null);
    const footerRef2 = useRef(null);
    const footerRef3 = useRef(null);
    const footerRef4 = useRef(null);
    const footerRef5 = useRef(null);
    const footerRef6 = useRef(null);
    const footerRef7 = useRef(null);
    const footerRef8 = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            checkFooterTexts();
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const checkFooterTexts = () => {
        if (footerRef1.current) {
            setIsOverflowingFooter1(
                footerRef1.current.scrollWidth >= footerRef1.current.offsetWidth
            );
        }
        if (footerRef2.current) {
            setIsOverflowingFooter2(
                footerRef2.current.scrollWidth >= footerRef2.current.offsetWidth
            );
        }
        if (footerRef3.current) {
            setIsOverflowingFooter3(
                footerRef3.current.scrollWidth >= footerRef3.current.offsetWidth
            );
        }
        if (footerRef4.current) {
            setIsOverflowingFooter4(
                footerRef4.current.scrollWidth >= footerRef4.current.offsetWidth
            );
        }
        if (footerRef5.current) {
            setIsOverflowingFooter5(
                footerRef5.current.scrollWidth >= footerRef5.current.offsetWidth
            );
        }
        if (footerRef6.current) {
            setIsOverflowingFooter6(
                footerRef6.current.scrollWidth >= footerRef6.current.offsetWidth
            );
        }
        if (footerRef7.current) {
            setIsOverflowingFooter7(
                footerRef7.current.scrollWidth >= footerRef7.current.offsetWidth
            );
        }
        if (footerRef8.current) {
            setIsOverflowingFooter8(
                footerRef8.current.scrollWidth >= footerRef8.current.offsetWidth
            );
        }
    };

    return (
        <div className="bottom-bar">
            <Col sm="12" className="bottom-bar-links">
                <a
                    href="#"
                    className="bottom-bar-links-notification"
                    onClick={(e) => { e.preventDefault(); toggleSupport(e); }}
                    id="footer-link-1"
                >
                    <Media src={helpImg} />
                    <span ref={footerRef1}>
                        {windowWidth > 1280 ? (
                            t('menu.help')
                        ) : (
                            t('menu.helpSmall')
                        )}
                    </span>
                </a>

                {footerRef1.current && (
                    <Tooltip
                        className="player-receivedGift-tooltip-old-blink"
                        placement="top"
                        isOpen={member.supportChatStatus && member.supportChatStatus.read === false}
                        target="footer-link-1"
                        container="div > div > div > div"
                    >
                        <div className="player-receivedGift-tooltip-from" style={{ wordWrap: 'normal' }}>
                            {t('menu.newMessage')}
                        </div>
                    </Tooltip>
                )}

                { isOverflowingFooter1 && (
                    <UncontrolledTooltip
                        className={`player-receivedGift-tooltip-old`}
                        placement="top"
                        target="footer-link-1"
                        container={'div > div > div > div'}
                        // trigger="click" // use for debug only
                    >
                        <div className="player-receivedGift-tooltip-from" style={{wordWrap: 'normal'}}>
                            {t('menu.help')}
                        </div>
                    </UncontrolledTooltip>
                )}

                <a
                    href="#"
                    className={`bottom-bar-links-notification ${!member?.tutorialBonus ? 'incoming-old' : ''}`}
                    onClick={(e) => {
                        e.preventDefault();
                        if (helpPageOpen) {
                            toggleHelp();
                        }
                        if (termsOfUseOpen) {
                            toggleTermsOfUse();
                        }
                        handleClickStart(e);
                    }}
                    id="footer-link-2"
                >
                    <Media src={quickHelpImg} />
                    <span ref={footerRef2}>
                        {windowWidth > 1280 ? (
                            t('menu.tutorial')
                        ) : (
                            t('menu.tutorialSmall')
                        )}
                    </span>
                </a>
                { isOverflowingFooter2 && (
                    <UncontrolledTooltip
                        className={`player-receivedGift-tooltip-old`}
                        placement="top"
                        target="footer-link-2"
                        container={'div > div > div > div'}
                        // trigger="click" // use for debug only
                    >
                        <div className="player-receivedGift-tooltip-from" style={{wordWrap: 'normal'}}>
                            {t('menu.tutorial')}
                        </div>
                    </UncontrolledTooltip>
                )}

                <a href="#" onClick={(e) => { e.preventDefault(); toggleBalanceHistory(e); }} id="footer-link-3">
                    <Media className="balance-hist-ico" src={moneyHistoryImg} />
                    <span ref={footerRef3}>
                        {windowWidth > 1280 ? (
                            t('menu.moneyHistory')
                        ) : (
                            t('menu.moneyHistorySmall')
                        )}
                    </span>
                </a>
                { isOverflowingFooter3 && (
                    <UncontrolledTooltip
                        className={`player-receivedGift-tooltip-old`}
                        placement="top"
                        target="footer-link-3"
                        container={'div > div > div > div'}
                        // trigger="click" // use for debug only
                    >
                        <div className="player-receivedGift-tooltip-from" style={{wordWrap: 'normal'}}>
                            {t('menu.moneyHistory')}
                        </div>
                    </UncontrolledTooltip>
                )}

                <a href="#" onClick={(e) => { e.preventDefault(); togglePointsHistory(e); }} id="footer-link-4">
                    <Media className="balance-hist-ico" src={pointsHistoryImg} />
                    <span ref={footerRef4}>
                        {windowWidth > 1280 ? (
                            t('menu.pointsHistory')
                        ) : (
                            t('menu.pointsHistorySmall')
                        )}
                    </span>
                </a>
                { isOverflowingFooter4 && (
                    <UncontrolledTooltip
                        className={`player-receivedGift-tooltip-old`}
                        placement="top"
                        target="footer-link-4"
                        container={'div > div > div > div'}
                        // trigger="click" // use for debug only
                    >
                        <div className="player-receivedGift-tooltip-from" style={{wordWrap: 'normal'}}>
                            {t('menu.pointsHistory')}
                        </div>
                    </UncontrolledTooltip>
                )}

                <a href="#" onClick={(e) => { e.preventDefault(); toggleBannedUsers(e); }} id="footer-link-5">
                    <Media src={blockedUsersImg} />
                    <span ref={footerRef5}>
                        {windowWidth > 1280 ? (
                            t('menu.bannedUsers')
                        ) : (
                            t('menu.bannedUsersSmall')
                        )}
                    </span>
                </a>
                { isOverflowingFooter5 && (
                    <UncontrolledTooltip
                        className={`player-receivedGift-tooltip-old`}
                        placement="top"
                        target="footer-link-5"
                        container={'div > div > div > div'}
                        // trigger="click" // use for debug only
                    >
                        <div className="player-receivedGift-tooltip-from" style={{wordWrap: 'normal'}}>
                            {t('menu.bannedUsers')}
                        </div>
                    </UncontrolledTooltip>
                )}

                <a href="#" onClick={(e) => { e.preventDefault(); toggleHelp(e); }} id="footer-link-6">
                    <Media src={gameHelpImg} />
                    <span ref={footerRef6}>
                        {windowWidth > 1280 ? (
                            t('menu.helpPage')
                        ) : (
                            t('menu.helpPageSmall')
                        )}
                    </span>
                </a>
                { isOverflowingFooter6 && (
                    <UncontrolledTooltip
                        className={`player-receivedGift-tooltip-old`}
                        placement="top"
                        target="footer-link-6"
                        container={'div > div > div > div'}
                        // trigger="click" // use for debug only
                    >
                        <div className="player-receivedGift-tooltip-from" style={{wordWrap: 'normal'}}>
                            {t('menu.helpPage')}
                        </div>
                    </UncontrolledTooltip>
                )}

                <a href="#" onClick={(e) => { e.preventDefault(); toggleAbout(e); }} id="footer-link-7">
                    <Media src={gameHelpImg} />
                    <span ref={footerRef7}>
                        {windowWidth > 1280 ? (
                            t('menu.aboutPage')
                        ) : (
                            t('menu.aboutPageSmall')
                        )}
                    </span>
                </a>
                { isOverflowingFooter7 && (
                    <UncontrolledTooltip
                        className={`player-receivedGift-tooltip-old`}
                        placement="top"
                        target="footer-link-7"
                        container={'div > div > div > div'}
                        // trigger="click" // use for debug only
                    >
                        <div className="player-receivedGift-tooltip-from" style={{wordWrap: 'normal'}}>
                            {t('menu.aboutPage')}
                        </div>
                    </UncontrolledTooltip>
                )}

                <a href="#" onClick={(e) => { e.preventDefault(); toggleTermsOfUse(e); }} id="footer-link-8">
                    <Media src={gameHelpImg} />
                    <span ref={footerRef8}>
                        {windowWidth > 1280 ? (
                            t('menu.termsOfUse')
                        ) : (
                            t('menu.termsOfUseSmall')
                        )}
                    </span>
                </a>
                { isOverflowingFooter8 && (
                    <UncontrolledTooltip
                        className={`player-receivedGift-tooltip-old`}
                        placement="top"
                        target="footer-link-8"
                        container={'div > div > div > div'}
                        // trigger="click" // use for debug only
                    >
                        <div className="player-receivedGift-tooltip-from" style={{wordWrap: 'normal'}}>
                            {t('menu.termsOfUse')}
                        </div>
                    </UncontrolledTooltip>
                )}
            </Col>
        </div>
    );
};

export default BottomBarOld;
